import { Panel, PanelBody, PanelHeader } from "../../components/panel/panel";
import Chart from 'react-apexcharts';
import moment from 'moment';

export const HeartBeatChart = ({ series, day }) => {

    const date = moment(day).toDate();
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayName = days[date.getDay()];


    const displayDayString = `${dayName} ${date.toLocaleDateString()}` ;

    const timeDisplay = date => {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const time = `${hours}:${minutes}:${seconds}`;
        return time;
    };

    const chartSettings = {
        series: [{
            name: 'Active',
            data: series.map(d => d.active)
        }],
        options: {
            colors: ['#00acac', '#348fe2'],
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.9,
                    opacityTo: 0.5,
                    stops: [0, 100]
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                offsetY: 15,
                offsetX: 500,
                labels: { colors: '#000000' }
            },
            stroke: {
                curve: 'stepline'
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: series.map((d, index) => { return index % 2 === 0 ? timeDisplay(moment(d.time).toDate()) : '' /* return d.time;*/ }), // Show only half-hourly labels
                title: {
                    text: 'Time (15-minute intervals)'
                },

                labels: {
                    format: 'HH:mm',
                    show: true,
                    rotate: -55,
                    rotateAlways: true,
                    style: { colors: '#000000' }
                }
            },
            yaxis: {
                // title: {
                //     text: 'Activity'
                // },
                labels: {
                    style: { colors: '#ffffff' },
                    formatter: val => {
                        return val === 1 ? 'Active' : 'Inactive';
                    }
                },
                min: 0,
                max: 1,
                tickAmount: 1
            },
            tooltip: {
                y: {
                    formatter: val => {
                        return val === 1 ? 'Active' : 'Inactive';
                    }
                }
            },
            grid: {
                show: true, borderColor: 'rgba(255,255,255, .15)',
                xaxis: { lines: { show: true } },
                yaxis: { lines: { show: true } },
                padding: { top: 0, right: 10, bottom: 0, left: 10 }
            },
            chart: { height: '100%', zoom: { autoScaleYaxis: true, autoScaleXaxis: true }, type: 'area', toolbar: { show: true }, stacked: false },
            plotOptions: { bar: { horizontal: false, columnWidth: '55%', endingShape: 'rounded' } },
        }
    };

    return (
        <div className="row">
            <div className="col-xl-12">
                <Panel showReload={false} showDelete={false}>
                    <PanelHeader title="User Activity">{displayDayString}</PanelHeader>
                    <PanelBody>
                        <div className="card-body p-0">
                            <div className="widget-chart-full-width pe-4" data-bs-theme="dark">
                                <Chart options={chartSettings.options} series={chartSettings.series} type="area" height="350" />
                            </div>
                        </div>
                    </PanelBody>
                </Panel>
            </div>
        </div>

    );
}